import axios from "axios";

const baseDomain = process.env.VUE_APP_RESULTS_REPOSITORY_URL;
const baseURL = `${baseDomain}/api/v1`;
const instance = axios.create({ baseURL });

instance.interceptors.request.use(config => {
  let token = localStorage.getItem("auth__access_token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  if (process.env.VUE_APP_LABORATORY_ID) {
    if (!config.params) {
      config.params = {};
    }
    if (!config.params.where) {
      config.params.where = {};
    }
    config.params.where.laboratory_id = process.env.VUE_APP_LABORATORY_ID;
  }
  return config;
});

export default instance;
